import { connect } from 'react-redux';

import ActivitiesList from './ActivitiesList';

const mapStateToProps = ({ admin: { activities: { list: activities } } }) => ({
  activities,
  categories: [...new Set(activities.reduce((categories, { value: { category } }) =>
    [...categories, category], []))],
});

export default connect(mapStateToProps)(ActivitiesList);



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivitiesList/index.js